var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current inline",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"aria-labelledby":_vm.type,"role":"presentation"}},[_c(_vm.iconName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }